import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import DataAddress from '../../data-address/DataAddress'
import {
  ControlLabel,
  SubTitle,
} from '../../common/form-components/label/Label'
import { getAllCenters } from '../../../services/own-centers/centers.slice'
import useInputs from '../../../utils/hooks/useInputs'
import LabeledDropdown from '../../common/form-components/labeled-dropdown/LabeledDropdown'
import LabeledCheckbox from '../../common/form-components/labeled-checkbox/LabeledCheckbox'
import LabeledText from '../../common/form-components/labeled-inputs/LabeledText'
import LabeledNumber from '../../common/form-components/labeled-inputs/LabeledNumber'
import MatrixInput from '../../common/form-components/matrix-inputs/MatrixInputs'
import './fuelStationsOwnDataForm.scss'
import LabeledPrice from '../../common/form-components/labeled-inputs/LabeledPrice'

const FuelStationsOwnDataForm = ({ inputs, onHandleChange, isOnlyInfo }) => {
  const dispatch = useDispatch()

  const centers = useSelector((state) => state.centers)?.resp

  const { inputs: dataAdress, updateInputs } = useInputs()

  useEffect(() => {
    dispatch(getAllCenters({}))
  }, [])

  useEffect(() => {
    updateInputs(getDataAdrress())
  }, [inputs?.center])

  const getDataAdrress = () => {
    if (_.has(inputs?.center, 'basicData')) {
      const center = {
        _id: inputs?.center?._id,
        ...inputs?.center?.basicData,
      }
      return center
    }
    return _.find(centers, ['_id', inputs?.center])
  }

  return (
    <div className="fuel-station-own-data">
      <SubTitle id="fuelStation.general.data" />
      {/* Datos de la estación */}
      <div className="fuel-station-data">
        <div className="wrapper-flex">
          {/* Rotulo */}
          <LabeledText
            idLabel="sign"
            required
            name="label"
            value={inputs?.label}
            onChange={(e) => onHandleChange(e)}
            disabled={isOnlyInfo}
          />
          {/* Centro */}

          <LabeledDropdown
            idLabel="center"
            required
            name="center"
            value={inputs?.center?._id || inputs?.center}
            options={centers}
            optionLabel="basicData.name"
            optionValue="_id"
            onChange={(e) => onHandleChange(e)}
            disabled={isOnlyInfo}
          />
        </div>
        {/* Datos del centro */}
        <DataAddress data={dataAdress} isDisabled />
      </div>

      {/* Datos de conexiones Minetur  */}
      <div className="fuel-station-connections">
        <SubTitle id="minetur" />
        <div className="wrapper-flex">
          <LabeledNumber
            idLabel="idMinetur"
            required
            name="minetur.id"
            value={inputs?.minetur?.id}
            onChange={(e) => onHandleChange(e)}
            disabled={isOnlyInfo}
          />

          <LabeledText
            idLabel="minetur.user"
            required
            name="minetur.user"
            value={inputs?.minetur?.user}
            onChange={(e) => onHandleChange(e)}
            disabled={isOnlyInfo}
          />

          <LabeledText
            idLabel="minetur.key"
            required
            name="minetur.key"
            value={inputs?.minetur?.key}
            onChange={(e) => onHandleChange(e)}
            disabled={isOnlyInfo}
          />

          <LabeledText
            idLabel="cins"
            required
            name="minetur.cins"
            value={inputs?.minetur?.cins}
            type="text"
            onChange={(e) => onHandleChange(e)}
            disabled={isOnlyInfo}
          />

          <LabeledText
            idLabel="alvic.code"
            required
            name="monolith"
            value={inputs?.monolith}
            onChange={(e) => onHandleChange(e)}
            disabled={isOnlyInfo}
          />
        </div>
      </div>

      {/* Datos configuraciones */}
      <div className="fuel-settings">
        <SubTitle id="settings" />
        <div className="fuel-station-settings">
          <div className="wrapper-content">
            <div className="wrapper-flex">
              <LabeledCheckbox
                idLabel="roundOut"
                name="prices.roundOut"
                onChange={(e) => onHandleChange(e)}
                checked={inputs?.prices?.roundOut}
                disabled={isOnlyInfo}
              />
              <LabeledCheckbox
                idLabel="prices.update.auto"
                specificClass="mr__05"
                name="prices.auto"
                onChange={(e) => onHandleChange(e)}
                checked={inputs?.prices?.auto}
                disabled={isOnlyInfo}
              />
              <LabeledText
                idLabel="transporter.email"
                name="transporter.email"
                value={inputs?.transporter?.email}
                onChange={(e) => onHandleChange(e)}
                disabled={isOnlyInfo}
              />
              <LabeledPrice
                idLabel="transporter.price"
                name="transporter.price"
                value={inputs?.transporter?.price}
                onChange={(e) => onHandleChange(e)}
                disabled={isOnlyInfo}
              />
            </div>
          </div>
          <div className="flex-metrix">
            <ControlLabel id="transport.tanks.GOA.G95" />
            <MatrixInput
              name="transporter.tankDistributions"
              initialValues={inputs?.transporter?.tankDistributions}
              onChange={onHandleChange}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default FuelStationsOwnDataForm
